export default __webpack_public_path__ + "static/CAResaleCertificate-f261bcbfa52cf5eff1720eeaa6b092e7.pdf";